export var window = (window as any) || globalThis;